import React from "react";
import { useSelector } from "react-redux";
import { DeleteConventionModal } from "./components";
import { Button } from "../../../../../../components";
import { getSelfServiceCnameSelector } from "../../../../../../store/selfServiceSlice";
import { useHandlers } from "./hooks";
import "./index.scss";

/**
 * @desc Button for deleting a convention.
 */
export const ButtonDeleteConvention = () => {
  // CONSTANTS ----------------------------------------------------------------

  const cname = useSelector(getSelfServiceCnameSelector);

  // HANDLERS -----------------------------------------------------------------

  const { handleClick } = useHandlers();

  // COMPONENT ----------------------------------------------------------------

  if (!cname) return;

  const props = {
    className: "btn-danger button-delete-convention",
    children: 'DELETE CONVENTION',
    onClick: handleClick,
    disabled: !cname,
  };

  return (
    <div className="button-delete-convention-container" >
      <DeleteConventionModal cname={cname} />
      <Button {...props} />
    </div>
  );
};
